const UTILS = require("../libs/utils.js");
const config = require("../config.js");
module.exports = function (RENDER, THREE) {
  if (!THREE.BufferGeometryUtils) {
    THREE.BufferGeometryUtils = require("../libs/BufferGeometryUtils.js")(THREE);
  }
  var vThis139 = this;
  var v13630 = new THREE.BoxGeometry(1, 1, 1);
  var v13631 = new THREE.CylinderGeometry(1, 1, 1, 12, 1, false);
  this.genCube = RENDER ? RENDER.genColorCube : function (p16984, p16985, p16986, p16987, p16988, p16989) {
    var v13632 = new THREE.BufferGeometry();
    var v13633 = new THREE.Mesh(p16989 && p16989.cyl ? v13631 : v13630);
    vThis139.scaleMesh(v13633, p16984, p16985, p16986);
    vThis139.moveMesh(v13633, 0, (p16988 || 0) * p16985, 0);
    return new THREE.Mesh(v13632);
  };
  this.genObj3D = function (p16990, p16991, p16992) {
    var v13634 = new THREE.Object3D();
    vThis139.moveMesh(v13634, p16990 || 0, p16991 || 0, p16992 || 0);
    return v13634;
  };
  this.merge = function (p16993, p16994) {
    p16994.updateMatrix();
    var v13635 = p16994.geometry.clone();
    v13635.applyMatrix4(p16994.matrix);
    p16994.geometry = v13635;
    let vA773 = [p16993, v13635];
    for (var vLN02511 = 0; vLN02511 < vA773.length; vLN02511++) {
      let v13636 = vA773[vLN02511];
      if (v13636 != null && v13636.index != null) {
        v13636 = v13636.toNonIndexed();
      }
      if (v13636 && v13636.attributes && (!v13636.attributes || !v13636.attributes.color)) {
        for (var v13637 = (v13636.attributes && v13636.attributes.position ? v13636.attributes.position.count : 0) * 3, v13638 = new Float32Array(v13637), vLN02511 = 0; vLN02511 < v13637; vLN02511++) {
          v13638[vLN02511] = 1;
        }
        v13636.setAttribute("color", new THREE.BufferAttribute(v13638, 3));
      }
      if (!v13636.attributes || !v13636.attributes.color) {
        v13636.setAttribute("color", new THREE.BufferAttribute(new Float32Array(0), 3));
      }
      if (!v13636.attributes || !v13636.attributes.uv) {
        v13636.setAttribute("uv", new THREE.BufferAttribute(new Float32Array(0), 2));
      }
      if (!v13636.attributes || !v13636.attributes.normal) {
        v13636.setAttribute("normal", new THREE.BufferAttribute(new Float32Array(0), 3));
      }
      if (!v13636.attributes || !v13636.attributes.position) {
        v13636.setAttribute("position", new THREE.BufferAttribute(new Float32Array(0), 3));
      }
    }
    return THREE.BufferGeometryUtils.mergeGeometries(vA773);
  };
  this.moveMesh = function (p16995, p16996, p16997, p16998) {
    if (p16995) {
      if (p16996 != null) {
        p16995.position.x = p16996;
      }
      if (p16997 != null) {
        p16995.position.y = p16997;
      }
      if (p16998 != null) {
        p16995.position.z = p16998;
      }
    }
  };
  this.scaleMesh = function (p16999, p17000, p17001, p17002) {
    p16999.scale.set(p17000, p17001, p17002);
  };
  this.rotateMesh = function (p17003, p17004, p17005, p17006) {
    if (p17003) {
      if (p17004 || p17004 == 0) {
        p17003.rotation.y = p17004;
      }
      if (p17005 || p17005 == 0) {
        p17003.rotation.x = p17005;
      }
      if (p17006 || p17006 == 0) {
        p17003.rotation.z = p17006;
      }
    }
  };
  var vO435 = {};
  this.genLeg = function (p17007, p17008, p17009, p17010) {
    p17010 = p17010 || {};
    p17010.us = p17010.det;
    var v13639 = config.legScale + (p17010.pad || 0);
    var v13640 = config.legHeight + (p17010.pad || 0);
    var v13650 = null;
    if (p17010.crouch) {
      var v13642 = (p17010.texSrc || "default") + (p17008 + "-" + p17009 + "-" + (p17010.crouch || "") + "-" + (p17010.rgb ? "rgb" : "") + (p17010.legLen ? "legLen" + p17010.legLen : "") + (p17010.movT == null ? "mt" : p17010.movT) + (p17010.movD == null ? "md" : p17010.movD) + (p17010.rotT == null ? "rt" : p17010.rotT) + (p17010.pad == null ? "np" : p17010.pad) + (p17010.projection ? "pj" : "") + (p17010.video == null ? "" : "v_" + p17010.video));
      v13650 = vO435[v13642];
      if (!v13650) {
        var v13643 = config.legHeight / 2 + (p17010.pad || 0);
        var v13644 = v13639 / 2 + (p17010.pad || 0);
        var vA774 = [0.5, 2];
        var v13645 = vThis139.genCube(v13639, v13643, v13639, [[p17008, 1]], 0, {
          us: p17010.det,
          uvScale: p17010.uvScale
        });
        vThis139.moveMesh(v13645, 0, -(v13643 / 2 * Math.cos(vA774[1])), -(v13643 / 2 * Math.sin(vA774[1])));
        vThis139.rotateMesh(v13645, 0, vA774[1], 0);
        var v13646 = Math.sqrt(v13644 * v13644 + v13644 * v13644 - v13644 * 2 * v13644 * Math.cos(vA774[0] - vA774[1]));
        var v13647 = Math.sqrt(v13644 * v13644 - v13646 / 2 * (v13646 / 2)) * 2;
        var v13648 = vThis139.genCube(v13639, v13646, v13647, [[p17008, 1]], 0, {
          us: p17010.det,
          uvScale: p17010.uvScale
        });
        vThis139.moveMesh(v13648, 0, -(v13643 * Math.cos(vA774[1])), -(v13643 * Math.sin(vA774[1])));
        vThis139.rotateMesh(v13648, 0, (vA774[1] + vA774[0]) / 2, 0);
        var v13649 = vThis139.genCube(v13639, v13643, v13639, [[p17008, 0.5, 1, 0.8], [p17009, 0.5]], 0, {
          us: p17010.det,
          uvScale: p17010.uvScale
        });
        vThis139.moveMesh(v13649, 0, -v13643 * Math.cos(vA774[1]) - v13643 / 2 * Math.cos(vA774[0]), -v13643 * Math.sin(vA774[1]) - v13643 / 2 * Math.sin(vA774[0]));
        vThis139.rotateMesh(v13649, 0, vA774[0], 0);
        var v13650 = new THREE.BufferGeometry();
        v13650 = vThis139.merge(v13650, v13645);
        v13650 = vThis139.merge(v13650, v13648);
        v13650 = vThis139.merge(v13650, v13649);
        vO435[v13642] = v13650;
      }
      if (RENDER) {
        v13650 = THREE.BufferGeometryUtils.mergeVertices(v13650);
      }
      v13650 = new THREE.Mesh(v13650, RENDER ? RENDER.getMat(p17010.texSrc || "default", p17010) : undefined);
      vThis139.moveMesh(v13650, config.legScale / 2 * (p17007 ? -1 : 1), v13640 - config.crouchDst + 0.5, 0);
    } else {
      v13650 = vThis139.genCube(v13639, v13640, v13639, [[p17008, p17010.legLen ? p17010.legLen : 0.75, 1], [p17009, p17010.legLen ? 1 - p17010.legLen : 0.25, undefined, undefined, undefined, p17010.legLen]], -0.5, p17010);
      vThis139.moveMesh(v13650, config.legScale / 2 * (p17007 ? -1 : 1), v13640, 0);
    }
    v13650.receiveShadow = true;
    v13650.castShadow = vThis139.dynamicShadows;
    v13650.name = "leg";
    return v13650;
  };
  var vO436 = {};
  this.genHead = function (p17011, p17012) {
    p17012 = p17012 || {};
    var v13651 = (p17012.texSrc || "default") + (p17012.hairCol + "-" + p17012.skinCol + "-" + (p17012.rgb ? "rgb" : "") + "-" + (p17012.noHead ? "nh" : "") + "-" + (p17012.noHair ? "nhr" : "") + "-" + (p17012.movT == null ? "mt" : p17012.movT) + (p17012.movD == null ? "md" : p17012.movD) + (p17012.rotT == null ? "rt" : p17012.rotT) + (p17012.projection ? "pj" : "") + (p17012.video == null ? "" : "v_" + p17012.video) + (p17012.pad == null ? "" : "pd_" + p17012.pad));
    var v13652 = vO436[v13651];
    if (!v13652) {
      v13652 = new THREE.BufferGeometry();
      var v13653 = config.headScale + (p17012.pad || 0);
      if (!p17012.noHead) {
        var v13654 = vThis139.genCube(v13653, v13653, v13653, [[p17012.hairCol, 0.2, 1, 0.6, undefined, !!p17012.noHair], [p17012.skinCol, 0.8]], 0, {
          us: p17011,
          uvScale: p17012.uvScale
        });
        vThis139.moveMesh(v13654, 0, config.playerHeight - v13653 / 2 - config.legHeight, 0);
        v13652 = vThis139.merge(v13652, v13654);
        if (RENDER) {
          v13652 = THREE.BufferGeometryUtils.mergeVertices(v13652);
        }
      }
      vO436[v13651] = v13652;
    }
    var v13655 = new THREE.Mesh(v13652, RENDER ? RENDER.getMat(p17012.texSrc || "default", p17012) : undefined);
    v13655.receiveShadow = true;
    v13655.name = "head";
    v13655.castShadow = vThis139.dynamicShadows;
    return v13655;
  };
  var vO437 = {};
  var v13656 = new THREE.MeshBasicMaterial({
    side: 2
  });
  this.genBody = function (p17013, p17014) {
    p17014 = p17014 || {};
    var v13657 = (p17014.texSrc || "default") + (p17014.shirtCol + "-" + p17014.pantsCol + "-" + p17014.hairCol + "-" + p17014.waistCol + "-" + p17014.skinCol + "-" + (p17014.rgb ? "rgb" : "") + "-" + (p17014.noBody ? "nb" : "") + (p17014.movT == null ? "mt" : p17014.movT) + (p17014.movD == null ? "md" : p17014.movD) + (p17014.rotT == null ? "rt" : p17014.rotT) + (p17014.projection ? "pj" : "") + (p17014.video == null ? "" : "v_" + p17014.video) + (p17014.pad == null ? "" : "pd_" + p17014.pad));
    var v13658 = vO437[v13657];
    if (!v13658) {
      v13658 = new THREE.BufferGeometry();
      var v13659 = config.playerHeight - config.headScale - config.legHeight + (p17014.pad || 0);
      var v13660 = vThis139.genCube(config.chestWidth + (p17014.pad || 0), v13659, config.chestScale + (p17014.pad || 0), [[p17014.shirtCol, 0.8, 1, 0.8, undefined, !!p17014.noBody], [p17014.waistCol, 0.2, 1.05]], 0, {
        us: p17013,
        uvScale: p17014.uvScale
      });
      vThis139.moveMesh(v13660, 0, v13659 / 2, 0);
      v13658 = vThis139.merge(v13658, v13660);
      if (RENDER) {
        v13658 = THREE.BufferGeometryUtils.mergeVertices(v13658);
      }
      vO437[v13657] = v13658;
    }
    var v13661 = new THREE.Mesh(v13658, RENDER ? RENDER.getMat(p17014.texSrc || "default", p17014) : v13656);
    v13661.receiveShadow = true;
    v13661.name = "body";
    v13661.castShadow = vThis139.dynamicShadows;
    return v13661;
  };
  var vO438 = {};
  this.genArms = function (p17015, p17016, p17017, p17018, p17019) {
    p17018 = p17018 || {};
    var v13662 = (p17018.texSrc || "default") + p17015.name + "-" + p17018.shirtCol + "-" + p17018.sleeveCol + "-" + p17018.skinCol + "-" + p17017 + "-" + (p17016 || 0) + "-" + (p17018.rgb ? "rgb" : "") + (p17018.movT == null ? "mt" : p17018.movT) + (p17018.movD == null ? "md" : p17018.movD) + (p17018.rotT == null ? "rt" : p17018.rotT) + (p17018.leftHoldZ || 0) + (p17018.armS ? p17018.armS : "") + "-" + (p17018.noSleeve ? 1 : 0) + (p17018.leftHoldX || 0) + (p17018.leftHoldY || 0) + (p17018.rightHoldY || 0) + (p17018.noRightHand ? "nrh" : "rh") + (p17018.projection ? "pj" : "") + (p17018.video == null ? "" : "v_" + p17018.video) + (p17018.noLeftSleeve ? "nls" : "ls") + (p17018.hasWrist == null ? "" : "hw");
    var v13663 = vO438[v13662];
    if (!v13663) {
      v13663 = new THREE.BufferGeometry();
      var v13664 = (-config.chestWidth + config.armScale / 2 - config.armInset) * (p17017 ? p17015.holdW || 0.4 : 1);
      var vO439 = {};
      if (!p17016 || p17016 == 1) {
        var v13666 = vThis139.genArm(v13664, config.armOff, p17015, true, p17018.shirtCol, p17018.sleeveCol, p17018.skinCol, p17017, p17018, p17019);
        if (RENDER) {
          vO439.l = {
            startP: v13666.startP,
            endP: v13666.endP,
            quat: v13666.quat
          };
        }
        v13663 = vThis139.merge(v13663, v13666);
      }
      if (!p17016 || p17016 == 2) {
        var v13666 = vThis139.genArm(-v13664, config.armOff, p17015, false, p17018.shirtCol, p17018.sleeveCol, p17018.skinCol, p17017, p17018, p17019);
        if (RENDER) {
          vO439.r = {
            startP: v13666.startP,
            endP: v13666.endP,
            quat: v13666.quat
          };
        }
        v13663 = vThis139.merge(v13663, v13666);
      }
      if (RENDER && !p17019) {
        v13663 = THREE.BufferGeometryUtils.mergeVertices(v13663);
      }
      v13663.tVecs = vO439;
      vO438[v13662] = v13663;
    }
    var v13667 = v13663.tVecs;
    v13663 = new THREE.Mesh(v13663, RENDER ? RENDER.getMat(p17018.texSrc || "default", p17018) : undefined);
    v13663.position.z += p17017 ? p17015.hDstOff || 0 : 0;
    v13663.receiveShadow = true;
    v13663.castShadow = !p17017 && vThis139.highResShad;
    return {
      mesh: v13663,
      vecs: v13667
    };
  };
  this.genArm = function (p17020, p17021, p17022, p17023, p17024, p17025, p17026, p17027, p17028, p17029) {
    var v13668 = p17023 ? p17028.leftHoldY || p17022.leftHoldY : p17028.rightHoldY || p17022.rightHoldY;
    var v13669 = p17023 ? p17028.leftHoldZ || p17022.leftHoldZ : p17028.rightHoldZ || p17022.rightHoldZ;
    v13669 += p17027 ? p17022.hDstOff || 0 : 0;
    var v13670 = p17023 ? p17028.leftHoldX || p17022.leftHoldX || 0 : p17028.rightHoldX || p17022.rightHoldX || 0;
    var v13671 = config.armScale * (p17027 ? 0.68 : 1) * (p17028.armS || 1) + (p17028.pad || 0);
    var v13672 = Math.min(config.uArmLength + config.lArmLength - 0.01, UTILS.getD3D(p17020, p17021, 0, (p17022.xOff - v13670) * (p17023 && p17022.akimbo ? -1 : 1), p17022.yOff + v13668, p17022.zOff - v13669));
    var v13673 = UTILS.getAnglesSSS(v13672, config.uArmLength, config.lArmLength);
    var v13674 = Math.PI / 2;
    if (!p17027) {
      var v13675 = vThis139.genCube(v13671, config.uArmLength, v13671, [[p17024, 1]], 0, {
        us: p17027,
        cyl: RENDER && RENDER.roundArms,
        uvScale: p17028.uvScale
      });
      vThis139.moveMesh(v13675, 0, -(config.uArmLength / 2 * Math.cos(v13674)), -(config.uArmLength / 2 * Math.sin(v13674)));
      vThis139.rotateMesh(v13675, 0, v13674, 0);
      var v13676 = v13671 / 2;
      var v13677 = Math.sqrt(v13676 * v13676 + v13676 * v13676 - v13676 * 2 * v13676 * Math.cos(Math.PI + v13673[0] + Math.PI / 2));
      var v13678 = Math.sqrt(v13676 * v13676 - v13677 / 2 * (v13677 / 2)) * 2;
      var v13679 = vThis139.genCube(v13671, v13677, v13678, [[p17024, 1]], 0, {
        us: p17027,
        cyl: RENDER && RENDER.roundArms,
        uvScale: p17028.uvScale
      });
      vThis139.moveMesh(v13679, 0, -(config.uArmLength * Math.cos(v13674)), -(config.uArmLength * Math.sin(v13674)));
      vThis139.rotateMesh(v13679, 0, (v13674 + v13673[0]) / 2, 0);
    }
    var v13680 = vThis139.genCube(v13671, config.lArmLength, v13671, [[p17024, 0.65, 1, 0.6], [!p17028.noSleeve && p17023 && p17028.noLeftSleeve ? p17024 : p17025, 0.15, p17028.noSleeve || p17023 && p17028.noLeftSleeve ? 1 : 1.1], [p17026, 0.2, 1, 0.5, true, !p17023 && p17028.noRightHand]], 0, {
      us: p17027,
      noAmb: p17028.noSleeve || p17023 && p17028.noLeftSleeve,
      cyl: RENDER && RENDER.roundArms,
      uvScale: p17028.uvScale
    });
    var v13681 = config.lArmLength / 2;
    vThis139.moveMesh(v13680, 0, -config.uArmLength * Math.cos(v13674) - v13681 * Math.cos(v13673[0]), -config.uArmLength * Math.sin(v13674) - v13681 * Math.sin(v13673[0]));
    vThis139.rotateMesh(v13680, 0, v13673[0], 0);
    var v13682;
    if (p17029) {
      v13682 = vThis139.genCube(0.1, 1, 0.1, [[p17024, 0.15, 1.1]], -1, {
        us: p17027
      });
      v13682.position.copy(v13680.position);
      v13682.rotation.copy(v13680.rotation);
    }
    var v13683 = new THREE.BufferGeometry();
    if (!p17027) {
      v13683 = vThis139.merge(v13683, v13675);
      v13683 = vThis139.merge(v13683, v13679);
    } else {
      var v13684 = vThis139.genCube(v13671, 20, v13671, [[p17024, 1]], 0, {
        us: p17027,
        noAmb: true,
        cyl: RENDER && RENDER.roundArms,
        uvScale: p17028.uvScale
      });
      vThis139.moveMesh(v13684, 0, -config.uArmLength * Math.cos(v13674) - Math.cos(v13673[0]) * -10, -config.uArmLength * Math.sin(v13674) - Math.sin(v13673[0]) * -10);
      vThis139.rotateMesh(v13684, 0, v13673[0], 0);
      v13683 = vThis139.merge(v13683, v13684);
    }
    v13683 = vThis139.merge(v13683, v13680);
    const v13685 = v13682 && v13682.geometry.attributes && v13682.geometry.attributes.position ? v13682.geometry.attributes.position.array.length : 0;
    const v13686 = v13683.attributes && v13683.attributes.position ? v13683.attributes.position.array.length : 0;
    if (p17029) {
      v13683 = vThis139.merge(v13683, v13682);
    }
    v13683 = new THREE.Mesh(v13683);
    vThis139.moveMesh(v13683, p17020 - p17022.xOff, p17021 - p17022.yOff, -p17022.zOff);
    v13683.rotation.order = "YXZ";
    v13683.rotation.x = -v13673[1] - UTILS.getDir(0, p17021, p17022.zOff - v13669, p17022.yOff + v13668);
    v13683.rotation.y = UTILS.getDir(-p17020, 0, (p17023 && p17022.akimbo ? 1 : -1) * (p17022.xOff - v13670), p17022.zOff - v13669) - Math.PI / 2;
    if (RENDER && p17029) {
      v13683.startP = v13686;
      v13683.endP = v13686 + v13685;
      const v13687 = new THREE.Object3D();
      v13687.add(v13682);
      v13687.rotation.order = "YXZ";
      v13687.rotation.x = -v13673[1] - UTILS.getDir(0, p17021, p17022.zOff - v13669, p17022.yOff + v13668);
      v13687.rotation.y = UTILS.getDir(-p17020, 0, (p17023 && p17022.akimbo ? 1 : -1) * (p17022.xOff - v13670), p17022.zOff - v13669) - Math.PI / 2;
      v13683.quat = v13682.getWorldQuaternion(new THREE.Quaternion());
      v13687.clear();
    }
    return v13683;
  };
};